export default __webpack_public_path__ + "static/media/banner.c8f2c7de.png";